
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program",
      function () {
        return require("private-next-pages/program/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program"])
      });
    }
  